// extracted by mini-css-extract-plugin
module.exports = {"bgTop":"archivecollaboration-module--bgTop--3gvaO","bgBottom":"archivecollaboration-module--bgBottom--1OckY"};